import { checkId } from '../../../../constants/form';
import { image } from '../../../../utils/data/baseUrl';
import { FOR_ID } from '../../wish';

export default {
  title: 'friends.title',
  text: 'friends.text',
  note: 'friends.note',
  buttons: [
    {
      text: 'friends.buttons.0.text',
    },
    {
      text: 'friends.buttons.1.text',
    },
  ],
  presents: {
    title: 'friends.presents.title',
    wishType: 'id',
    text: 'friends.presents.text',
    buttons: [
      {
        timeout: 1000,
        action: 'send',
        attr: {
          icon: 'buttons/present-icon',
          text: 'friends.presents.buttons.0.text',
          className: 'friends__send button_green custom-button_present',
        },
      },
      {
        timeout: 1000,
        action: 'look',
        attr: {
          text: 'friends.presents.buttons.1.text',
          className: 'friends__look custom-button_gray',
        },
      },
    ],
    modal: {
      title: 'friends.presents.modal.title',
      wishType: FOR_ID,
      input: {
        type: 'number',
        min: 0,
        placeholder: 'friends.presents.modal.input.placeholder',
        autoFocus: false,
        autoComplete: '',
        name: 'id',
        rules: checkId,
      },
      buttons: [
        {
          text: 'friends.presents.modal.buttons.0.text',
          timeout: 6000,
          className: 'custom-button wish-modal__button',
        },
        {
          disposable: true,
          type: 'button',
          modalData: { action: 'close', data: { type: 'current' } },
          text: 'friends.presents.modal.buttons.1.text',
          className: 'custom-button_gray wish-modal__button',
        },
      ],
    },
  },
  achievements: {
    title: 'friends.achieves.title',
    text: 'friends.achieves.text',
  },
  postcard: {
    bg: {
      imgAttr: {
        src: image('friends/postcard-bg-8march.png'),
        alt: '',
      },
    },
    text: 'friends.postcard.text',
    button: {
      text: 'friends.postcard.button.text',
      className: 'friends__postcard-button button_postcard-create button_white',
    },
    modalForId: {
      wishType: FOR_ID,
      title: 'friends.postcard.modalId.title',
      input: {
        type: 'number',
        min: 0,
        placeholder: 'friends.postcard.modalId.input.placeholder',
        autoFocus: false,
        autoComplete: '',
        name: 'id',
        rules: checkId,
      },
      buttons: [
        {
          text: 'friends.postcard.modalId.buttons.0.text',
          timeout: 3000,
          className: 'custom-button wish-modal__button',
        },
        {
          type: 'button',
          modalData: { action: 'close', data: { type: 'current' } },
          text: 'friends.postcard.modalId.buttons.1.text',
          className: 'custom-button_gray wish-modal__button',
        },
      ],
    },
    available: 'friends.postcard.available',
  },
};
